import { render, staticRenderFns } from "./ViewNews.vue?vue&type=template&id=5a85f1b1&scoped=true"
import script from "./ViewNews.vue?vue&type=script&lang=js"
export * from "./ViewNews.vue?vue&type=script&lang=js"
import style0 from "./ViewNews.vue?vue&type=style&index=0&id=5a85f1b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85f1b1",
  null
  
)

export default component.exports